import React, { Component } from 'react';
import { DateRangePicker } from 'react-dates';
import ReactTable from 'react-table';
import Select from 'react-select';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import moment from 'moment';
import makeAnimated from 'react-select/lib/animated';
import update from 'immutability-helper';
import 'react-table/react-table.css';
import 'react-dates/lib/css/_datepicker.css';
import Logged from '../Logged/Logged';
import { Permissions } from '../../Utils/Permissions';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import InputTag from '../../Components/Input-Tag/Input-Tag';
import './Billing.scss';

class BillingReprocessList extends Component {

    constructor() {
        super();

        this.toggleFilters = this.toggleFilters.bind(this);
        this.getFaturamentosProcessados = this.getFaturamentosProcessados.bind(this);
        this.refreshTable = this.refreshTable.bind(this);
        this.filterSearch = this.filterSearch.bind(this);
        this.handleFocusChange = this.handleFocusChange.bind(this);
        this.handleDatesChange = this.handleDatesChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.permissaoFaturamento = this.permissaoFaturamento.bind(this);

        this._faturamentoFocusChange = this.handleFocusChange('faturamento').bind(this);
        this._faturamentoDatesChange = this.handleDatesChange('faturamento').bind(this);

        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);

        this.atualizaPedidos = this.atualizaPedidos.bind(this);

        this.Configurations = new Configurations();
        this.logged = new Logged();

        this.tipoProcessamentoOptions = [
            { label: "Novo Pedido", value: 1 },
            { label: "Cancelamento", value: 2 },
            { label: "Alteração de titular", value: 3 },
            { label: "Alteração de itens", value: 4 },
        ];

        this.statusProcessamentoOptions = [
            { label: "Processado", value: 1 },
            { label: "Não processado", value: 0 },
        ];

        this.state = {
            openFilters: true,
            filters: {
                faturamento: {
                    startDate: null,
                    endDate: null
                },
                listaTipoProcessamento: [],
                listaStatusProcessamento: [],
            },
            listaIdPedido: [],
            hasError: false,
            errorMessage: '',
        }

        this._phrases = {
            closeDatePicker: "Fechar",
            clearDates: "Limpar datas",
            calendarLabel: "Calendário"
        }

        this.columns = [
            {
                Header: 'id',
                accessor: 'faturamento',
                className: 'text-center pointer',
                // width: 60
            },
            {
                Header: 'Pedido',
                className: 'pointer text-center',
                accessor: 'idPedido',
                // width: 80,
            },
            {
                Header: 'Processamento',
                className: 'pointer text-center',
                accessor: 'nomeTipoProcessamento',
                // width: 130,
            },
            {
                Header: "Dt. Criação",
                accessor: 'dtCriacao',
                className: 'pointer text-center',
                // width: 130,
                Cell: row => (<span>{row.value !== undefined && row.value !== null ? moment(row.value).format('DD/MM/YY HH:mm') : '-'}</span>)
            },
            {
                Header: "Dt. Modificação",
                accessor: 'dtModificacao',
                className: 'pointer text-center',
                // width: 130,
                Cell: row => (<span>{row.value !== undefined && row.value !== null ? moment(row.value).format('DD/MM/YY HH:mm') : '-'}</span>)
            },
            {
                Header: "Status",
                accessor: 'processado',
                className: 'pointer text-center',
                // width: 130,
                Cell: row => {
                    const _processado = row.value,
                        _label = _processado ? 'processado' : 'não processado',
                        _color = _processado ? 'success' : 'warning'
                    return (
                        <span className={`badge badge-${_color}`}>{_label}</span>
                    )
                }
            },
        ];

    }

    componentDidMount() {
    }

    permissaoFaturamento(_user) {
        const _arrPerm = _user.permissions,
            _paginas = _arrPerm.map(item => Permissions.pagesAccess(item)).flat(),
            _permAdmin = ["admin"].some(r => _paginas.indexOf(r) >= 0),
            _permFaturamento = ["faturamento"].some(r => _paginas.indexOf(r) >= 0);
        return _permAdmin || _permFaturamento;
    }

    handleSelectChange(e, o) {
        const _name = o.name;
        let _list = this.state.filters[_name];
        switch (o.action) {
            case "remove-value":
                const _index = _list.findIndex(item => item === o.removedValue);
                _list.splice(_index, 1);
                //-- do
                break;
            case "clear":
                const _filters = this.state.filters;
                _filters[_name] = [];
                this.setState({
                    filters: _filters
                });
                return o;
            default:
                _list.push(o.option);
                break;
        }

        const _filters = update(this.state.filters, { $merge: { [_name]: _list } });
        this.setState({ _filters });

        return o;
    }

    toggleFilters() {
        this.setState({
            openFilters: !this.state.openFilters
        })
    }

    getFaturamentosProcessados(o) {
        this.setState({ loading: true });

        const _params = [];

        if (!o.pageSize) {
            o.pageSize = 20;
            _params.push(`qtdItens=${o.pageSize}`);
        } else if (!(o.page + 1)) {
            o.page = 1;
            _params.push(`pagina=${o.page}`);
        } else {
            _params.push(`qtdItens=${o.pageSize}`);
            _params.push(`pagina=${o.page + 1}`);
        }

        if (this.state.filters.listaTipoProcessamento.length > 0) {
            _params.push(`listaIdTipoProcessamento=${this.state.filters.listaTipoProcessamento.map(item => item.value).join(',')}`);
        }

        if (this.state.filters.listaStatusProcessamento.length === 1) {
            _params.push(`idProcessado=${this.state.filters.listaStatusProcessamento[0].value}`);
        }

        if (this.state.listaIdPedido.length > 0) {
            _params.push(`listaIdPedido=${this.state.listaIdPedido.join(',')}`);
        }

        if (moment(this.state.filters.faturamento.startDate).isValid()) {
            _params.push(`dtCriacaoInicio=${moment(this.state.filters.faturamento.startDate).format("DD/MM/YYYY")}`);
        }
        if (moment(this.state.filters.faturamento.endDate).isValid()) {
            _params.push(`dtCriacaoFim=${moment(this.state.filters.faturamento.endDate).format("DD/MM/YYYY")}`);
        }

        const _faturamentos = axios.get(this.Configurations.apiBasePath + `/faturamentos/reprocessar?${_params.join('&')}`);

        const _parametros = _params.join('&');

        _faturamentos.then(response => {
            this.setState({
                listaFaturamentoReprocessar: response.data.listaFaturamentosProcessar,
                pages: response.data.paginacao.totalPaginas,
                parametros: _parametros
            });
        }).catch(err => {
            if (err.response.status === 404) this.setState({
                listaFaturamentoReprocessar: [],
                pages: 1,
                parametros: _parametros
            })
        }).finally(() => this.setState({ loading: false }));
    }

    handleFocusChange(attr) {
        return function (focusedInput) {
            var dates = this.state.filters[attr];

            dates.focusedInput = focusedInput;
            let newState = {
            };
            newState[attr] = dates;
            this.setState(newState);
        }
    }

    handleDatesChange(attr) {
        return function ({ startDate, endDate }) {
            var dates = this.state.filters[attr];
            dates.startDate = startDate;
            dates.endDate = endDate;
            startDate ? dates.gte = startDate.format('YYYY[-]MM[-]DD') : delete dates.gte;
            endDate ? dates.lte = endDate.format('YYYY[-]MM[-]DD') : delete dates.lte;
            let newState = {
            };
            newState[attr] = dates;
            this.setState(newState);
        }
    }

    refreshTable(o) {
        this.getFaturamentosProcessados(o);
    }

    _outsideRange(day) {
        return day.format() > moment().format();
    }

    filterSearch(e) {
        e.preventDefault();
        // this.salvaParametros();
        this.getFaturamentosProcessados({});
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    atualizaPedidos(_lista) {
        this.setState({ listaIdPedido: _lista })
    }

    render() {
        return (
            <div className="faturamento">
                <div className="row">
                    <div className="col-9">
                        <h2 className="title-1">Faturamento - Lista de Reprocessamento</h2>
                    </div>
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header p-2" id="headingOne">
                                <div className="col-12">
                                    <button className="btn btn-link w-100 text-left" type="button" onClick={this.toggleFilters}>
                                        <i className={`fa mr-2 ${this.state.openFilters ? "fa-chevron-right" : "fa-chevron-down"}`}></i>
                                        Filtros
                                    </button>
                                </div>
                            </div>
                            <div className={`card-body ${!this.state.openFilters && "collapse"}`} id="boxFilters">
                                {this.state.loading ? (
                                    <div className="row no-gutters">
                                        <div className="col-12 text-center py-5">
                                            <div className="spinner-border text-primary" role="status" />
                                        </div>
                                    </div>
                                ) : (
                                        <form onSubmit={this.filterSearch} noValidate>
                                            <div className="row align-items-center">
                                                <div className="col-6">
                                                    <div className="form-group">
                                                        <label htmlFor="dpBillingStartDate">Criação do Faturamento</label><br />
                                                        <DateRangePicker
                                                            showClearDates
                                                            enableOutsideDays
                                                            isOutsideRange={this._outsideRange}
                                                            startDate={this.state.filters.faturamento.startDate} // momentPropTypes.momentObj or null,
                                                            startDateId="dpBillingStartDate" // PropTypes.string.isRequired,
                                                            endDate={this.state.filters.faturamento.endDate} // momentPropTypes.momentObj or null,
                                                            endDateId="dpBillingEndDate" // PropTypes.string.isRequired,
                                                            onDatesChange={this._faturamentoDatesChange} // PropTypes.func.isRequired,
                                                            focusedInput={this.state.filters.faturamento.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                                            onFocusChange={this._faturamentoFocusChange}
                                                            displayFormat="DD/MM/YYYY"
                                                            startDatePlaceholderText="Data inicial"
                                                            endDatePlaceholderText="Data final"
                                                            phrases={this._phrases}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className="form-group">
                                                        <label htmlFor="ddlTipoProcessamento">Tipo de processamento</label>
                                                        <Select
                                                            id="ddlTipoProcessamento"
                                                            placeholder="Selecione um ou mais tipos"
                                                            closeMenuOnSelect={true}
                                                            components={makeAnimated()}
                                                            defaultValue={this.state.filters.listaTipoProcessamento}
                                                            isMulti
                                                            name="listaTipoProcessamento"
                                                            onChange={this.handleSelectChange}
                                                            options={this.tipoProcessamentoOptions}

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-4 tags-pedido">
                                                    <label>Busca por pedido</label>
                                                    <InputTag atualizaTags={this.atualizaPedidos} tags={this.state.listaIdPedido} textInput={true} />
                                                    <small>Insira o nº do(s) pedido(s) e pressione "Enter" ou "Tab".</small>
                                                </div>
                                                <div className="offset-2 col-4">
                                                    <div className="form-group">
                                                        <label htmlFor="ddlStatusProcessamento">Status de processamento</label>
                                                        <Select
                                                            id="ddlStatusProcessamento"
                                                            placeholder="Selecione um ou mais status"
                                                            closeMenuOnSelect={true}
                                                            components={makeAnimated()}
                                                            defaultValue={this.state.filters.listaStatusProcessamento}
                                                            isMulti
                                                            name="listaStatusProcessamento"
                                                            onChange={this.handleSelectChange}
                                                            options={this.statusProcessamentoOptions}

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12 text-right">
                                                    <button className="btn btn-primary">Buscar</button>
                                                </div>
                                            </div>
                                        </form>

                                    )}

                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <ReactTable
                                    data={this.state.listaFaturamentoReprocessar}
                                    columns={this.columns}
                                    onFetchData={this.refreshTable}
                                    defaultPageSize={20}
                                    pages={this.state.pages}
                                    manual
                                    loading={this.state.loading}
                                    className="-striped -highlight table-atendimento"
                                    headerClassName="ebs-table-header"
                                    previousText='Anterior'
                                    nextText='Próxima'
                                    loadingText='Carregando...'
                                    noDataText='Nenhum faturamento processado encontrado.'
                                    pageText='Página'
                                    ofText='de'
                                    rowsText='linhas'
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                    goBack={false}
                />
            </div >
        )
    }
}

export default BillingReprocessList;